// extracted by mini-css-extract-plugin
export var dark = "HalfAndHalfHeader-module--dark--13645";
export var featuredSuper = "HalfAndHalfHeader-module--featured-super--2217d";
export var featuredSuperGold = "HalfAndHalfHeader-module--featured-super-gold--3cd5e";
export var grid = "HalfAndHalfHeader-module--grid--72949";
export var header = "HalfAndHalfHeader-module--header--62796";
export var headingContent = "HalfAndHalfHeader-module--heading-content--ea6d5";
export var headingSuper = "HalfAndHalfHeader-module--heading-super--f3b47";
export var heroImage = "HalfAndHalfHeader-module--hero-image--aed75";
export var section = "HalfAndHalfHeader-module--section--b564c";
export var slim = "HalfAndHalfHeader-module--slim--2a321";
export var useH1 = "HalfAndHalfHeader-module--use-h1--f0174";
export var verticalBleed = "HalfAndHalfHeader-module--vertical-bleed--8f3cc";
export var wistiaWrap = "HalfAndHalfHeader-module--wistia-wrap--eb378";